import { GATES } from '../constants/auth';
import { useGetIsUngated } from './useGetIsUngated';
export const useHasSeqReqChangesRedesign = () => {
  const getIsUngated = useGetIsUngated();
  return getIsUngated(GATES.SEQ_REQ_CHANGES_REDESIGN);
};